export const orderByText = {
  average: 'Řazeno dle aktuální úrovně dovedností',
  alphabetical: 'Řazeno abecedně'
};
